import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ label, value, onChange, options, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(option => option.value === value) || options[0];

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-900 mb-2">
        {label}
      </label>
      <div
        className="w-full p-3 border border-gray-300 rounded-lg cursor-pointer transition-all duration-200 select-none bg-white hover:bg-gray-50 active:bg-gray-100 flex items-center justify-between min-h-[48px] text-base"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-gray-900 font-medium">
          {selectedOption?.label || selectedOption?.value}
        </span>
        <svg
          className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full bg-white border border-gray-300 rounded-lg shadow-xl overflow-hidden top-full mt-1">
          {options.map((option, index) => (
            <div
              key={index}
              className="p-3 cursor-pointer transition-all duration-150 flex items-center justify-between min-h-[48px] hover:bg-blue-50 border-b border-gray-100 last:border-b-0 active:bg-blue-200 select-none text-gray-700"
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
            >
              <span className="flex-1">{option.label || option.value}</span>
              {option.value === value && (
                <div className="text-white bg-blue-600 rounded-full p-1 flex items-center justify-center min-w-[20px] min-h-[20px]">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown; 